<template>
  <!-- <transition name="header-slide-down">
    <div v-if="showMenu" ref="header" class="header-container">
      <headerMobile
        v-if="isMobileScreen"
        :info="contactInfo"
         />
      <headerPC
        v-else
        :info="contactInfo"
      />
    </div>
  </transition> -->
  <div ref="header" class="header-container">
    <div v-if="isMobileScreen">
      <headerMobile
        :info="contactInfo"
         />
    </div>
    <div v-else>
      <transition name="header-slide-down">
        <headerPC
          v-if="showMenu"
          :info="contactInfo"
        />
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "ylHeader",
  components: {
    headerMobile: () => import("./components/mobile.vue"),
    headerPC: () => import("./components/pc.vue"),
  },
  watch: {
    showMenu(newVal) {
      // console.log('showMenu changed to:', newVal);
    }
  },
  computed: {
    dataTheme() {
      return this.$store.getters.dataTheme;
    },
    isCollapse() {
      return this.$store.getters.isCollapse;
    },
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
    menuAutoHide() {
      return this.$store.getters.settings.menuAutoHide === 'true';
    },
    menuMouseMoveTopAreaShow() {
      return this.$store.getters.settings.menuMouseMoveTopAreaShow === 'true';
    },
  },
  data() {
    return {
      preScrollPos: 0, // 用于存储上一次的滚动位置
      startY: 0, // 开始时的y坐标
      threshold: 10, // 滑动阈值
      contactInfo: {}, // 联系方式信息
      showMenu: true, // 显示菜单
    };
  },
  created() {
    this.getContact();
  },
  mounted() {
    // 检查menuAutoHide配置
    // console.log('menuAutoHide:', this.menuAutoHide);
    // console.log('menuMouseMoveTopAreaShow:', this.menuMouseMoveTopAreaShow);
    
    // 监听事件
    document.addEventListener("keydown", this.handleEscKey);
    document.addEventListener("touchstart", this.handleTouchStart);
    document.addEventListener("touchmove", this.handleTouchMove);
    document.addEventListener("scroll", this.handleScroll);
    document.addEventListener("mousemove", this.handleMouseMove);
  },

  beforeDestroy() {
    // 在组件销毁前移除事件监听
    document.removeEventListener("keydown", this.handleEscKey);
    document.removeEventListener("touchstart", this.handleTouchStart);
    document.removeEventListener("touchmove", this.handleTouchMove);
    document.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("mousemove", this.handleMouseMove);
    // 在组件销毁前恢复主题及滚动条
    this.handleClose();
  },

  methods: {
    // 处理鼠标移动事件
    handleMouseMove(e) {
      if (this.menuAutoHide) {
        if (!this.menuAutoHide || !this.menuMouseMoveTopAreaShow) return;
        
        // const ref = this.$refs.header;
        // 检测鼠标是否在顶部100px区域
        if (e.clientY <= 100) {
          // 显示菜单
          // ref?.classList.remove("hidden-menu");
          this.showMenu = true;
        }
      }
    },
    // 获取联系方式
    async getContact() {
      const res = await this.$api.contact();
      this.contactInfo = res[0];
    },

    // 处理点击事件
    handleClose() {
      this.$store.dispatch("setting/setDataTheme", "dark");
      this.$store.dispatch("setting/setCollapse", false);
    },
    // 处理Esc键
    handleEscKey(event) {
      // 判断是否是 Esc 键
      if (event.key === "Escape" || event.keyCode === 27) {
        this.handleClose();
      }
    },
    // 处理滚动事件
    handleScroll() {
      if (this.isCollapse) return;
      this.$store.dispatch("setting/setDataTheme", "dark");
      const ref = this.$refs.header;
      // // 获取当前滚动位置
      const curScrollPos = window.scrollY;
      // // 滚动到顶部设置为黑色主题
      // if (curScrollPos === 0) {
      //   this.$store.dispatch("setting/setDataTheme", "dark");
      // }
      // // 否则为白色主题
      // else {
      // this.$store.dispatch("setting/setDataTheme", "dark");
      if (this.menuAutoHide) {
        // 向下滚动，隐藏组件
        if (curScrollPos > this.preScrollPos) {
          // ref?.classList.add("hidden-menu");
          this.showMenu = false;
        }
        // 向上滚动，显示组件
        else {
          // ref?.classList.remove("hidden-menu");
          this.showMenu = true;
        }
      }
      // }
      // 更新上一次滚动位置
      this.preScrollPos = curScrollPos;
    },
    // 处理触摸事件
    handleTouchStart(event) {
      // 记录触摸开始时的 y 坐标
      this.startY = event.touches[0].clientY;
    },
    // 处理触摸移动事件
    handleTouchMove(event) {
      if (this.dataTheme !== "dark") return;
      const ref = this.$refs.header;
      // 获取触摸移动时的 y 坐标
      const currentY = event.touches[0].clientY;
      // 计算滑动距离
      const distance = currentY - this.startY;
      // 判断滑动方向并更新组件的显示状态
      if (distance > this.threshold) {
        // 向上滑动，显示组件
        // ref?.classList.remove("hidden-menu");
        this.showMenu = true;
      } else if (distance < -this.threshold) {
        // 向下滑动，隐藏组件
        // ref?.classList.add("hidden-menu");
        this.showMenu = false;
      }
    },
  },
};
</script>
<style lang="scss">
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  transform-origin: top center;
  z-index: 2000;
}

.header-slide-down-enter-active,
.header-slide-down-leave-active {
  transition: all 0.3s ease-in-out;
}

.header-slide-down-enter,
.header-slide-down-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

.hidden {
  // opacity: 0;
  // visibility: hidden;
}
</style>
